/**
 * Estado de la empresa (Cuenta) — estados REALES del GX, catálogo completo
 * (pagoww.cs:1674-1675, filtro fulltext del grid de pagos):
 *   1 = inactiva · 2 = activa · 3 = mora · 4 = eliminar
 *   5 = limpia · 6 = prueba · 7 = vacaciones · 8 = cerrada
 *
 * [RGM] 2026-09-16 (reporte Rafael): la réplica usaba el mapeo viejo invertido
 * (1 = "Activa", 2|6 = "En prueba") — por eso al registrar un pago (que deja
 * la empresa en 2 = ACTIVA) la pantalla mostraba "En prueba". Se centraliza
 * aquí para que todas las pantallas usen la misma semántica GX.
 */
export interface EstadoEmpresaInfo {
  label: string
  color: string
}

export const estadoEmpresa = (estado: number): EstadoEmpresaInfo => {
  switch (estado) {
    case 1: return { label: 'Inactiva', color: 'danger' }
    case 2: return { label: 'Activa', color: 'success' }
    case 3: return { label: 'Mora', color: 'warning' }
    case 4: return { label: 'Eliminar', color: 'danger' }
    case 5: return { label: 'Limpia', color: 'secondary' }
    case 6: return { label: 'Prueba', color: 'info' }
    case 7: return { label: 'Vacaciones', color: 'info' }
    case 8: return { label: 'Cerrada', color: 'dark' }
    default: return { label: 'Pendiente', color: 'info' }
  }
}

/** Opciones del filtro de estado (orden del catálogo GX). */
export const ESTADOS_EMPRESA_OPCIONES = [
  'Inactiva', 'Activa', 'Mora', 'Eliminar', 'Limpia', 'Prueba', 'Vacaciones', 'Cerrada', 'Pendiente',
]
